import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { UserDetail } from "./userDetail.types";

export const userDetailSlice = createSlice({
  name: "userDetail",
  initialState: null as UserDetail | null,
  reducers: {
    setUserDetail: (state, action: PayloadAction<UserDetail>): UserDetail => {
      return action.payload;
    },
  },
});

export const { setUserDetail } = userDetailSlice.actions;

export default userDetailSlice.reducer;
